var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { CampaignService } from './campaign.service';
var CampaignReportComponent = /** @class */ (function (_super) {
    __extends(CampaignReportComponent, _super);
    function CampaignReportComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.defMode = '';
        //private hsl = 0;
        _this.colorSeq = 0;
        _this.condition = {};
        _this.monthOptions = new MonthOptions();
        _this.colors5 = [
            '#f95ab2',
            '#455700',
            '#ffb17f',
            '#031c6b',
            '#c2657f'
        ];
        _this.colors10 = [
            '#ff806b',
            '#006de1',
            '#64c34f',
            '#ff92fc',
            '#e6d57b',
            '#004289',
            '#890013',
            '#01b5fd',
            '#dd3e99',
            '#895997'
        ];
        _this.colors15 = [
            '#64eca9',
            '#d13c9f',
            '#4db444',
            '#311559',
            '#bce170',
            '#dd2d5f',
            '#386c00',
            '#ff6799',
            '#aba705',
            '#880003',
            '#c37c00',
            '#5f1d00',
            '#ff9050',
            '#f25451',
            '#aa564b'
        ];
        _this.colors20 = [
            '#ff8675',
            '#026ae0',
            '#f3d25e',
            '#560077',
            '#32ac43',
            '#9253c7',
            '#417200',
            '#ff95ff',
            '#c68600',
            '#018ee9',
            '#bc4b07',
            '#0bebed',
            '#640060',
            '#bcafff',
            '#682400',
            '#ea5abd',
            '#343775',
            '#ba388b',
            '#d82956',
            '#730054'
        ];
        return _this;
    }
    CampaignReportComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    CampaignReportComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (this.component.params && this.component.params.mode) {
            this.defMode = this.component.params.mode;
        }
    };
    CampaignReportComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    CampaignReportComponent.prototype.onSubscribe = function (data) {
        if (data.campaign_id) {
            this.condition['campaign_id'] = data.campaign_id;
            this.target = this.service.getTarget(this.rec, this.rec['send_number']);
            var canvas = this.canvasElement.nativeElement;
            canvas.width = 400;
            canvas.height = 200;
            // @TODO chart.js更新時にサイズがだんだん大きくなる、の暫定処置
            for (var i = 0; i <= 12; i++) {
                if (this.myChart) {
                    this.myChart.destroy();
                }
                this.myChart = new Chart(canvas);
            }
            var date = new Date();
            this.monthOptions.MinMonth = data.cdate.substring(0, 7).replace(/-/g, '/');
            this.monthOptions.MaxMonth = date.getFullYear() + '/' + (date.getMonth() + 1);
            // 初期表示は現在日時＋メディア別＋日別のレポート
            this.condition['category'] = 'media';
            this.changeDate(this.monthOptions.MaxMonth);
            this.action.setCompRec(this.componentName, data);
        }
    };
    CampaignReportComponent.prototype.onModeSubscribe = function (mode) {
        if (this.defMode !== mode) {
            this.action.deleteCompRec(this.componentName);
        }
    };
    CampaignReportComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    CampaignReportComponent.prototype.getGoalDataFormat = function () {
        var data = {
            type: 'line',
            fill: false,
            borderColor: 'rgba(0,0,0,0)',
            pointStyle: 'line',
            pointBorderColor: 'rgba(0,0,0,1)',
            yAxisID: 'y-axis-2'
        };
        return data;
    };
    CampaignReportComponent.prototype.getLindeDataFormat = function () {
        var data = {
            type: 'line',
            fill: false,
            lineTension: 0,
            pointBackgroundColor: '#fff',
            pointRadius: 5,
            pointHoverRadius: 8,
            pointHitRadius: 10,
            yAxisID: 'y-axis-1',
        };
        return data;
    };
    CampaignReportComponent.prototype.getTotalDataFormat = function () {
        var data = {
            type: 'bar',
            yAxisID: 'y-axis-2',
            backgroundColor: '#3dc0cc',
            borderColor: 'transparent',
        };
        return data;
    };
    CampaignReportComponent.prototype.getChartOption = function () {
        var data = {};
        data = {
            type: 'bar',
            options: {
                scales: {
                    xAxes: [{
                            gridLines: {
                                display: false
                            },
                            categoryPercentage: 1,
                            barPercentage: 0.9
                        }],
                    yAxes: [{
                            id: 'y-axis-1',
                            type: 'linear',
                            position: 'left',
                            ticks: {
                                beginAtZero: true,
                                callback: function (val) {
                                    if (Math.floor(val) === val) {
                                        return val;
                                    }
                                }
                            },
                            gridLines: {
                                display: false
                            },
                            scaleLabel: {
                                display: true,
                                labelString: this.msgSnapshot['CampaignReportComponent.item.leftAxis']
                            }
                        }, {
                            id: 'y-axis-2',
                            type: 'linear',
                            position: 'right',
                            ticks: {
                                min: 0,
                                beginAtZero: true,
                                callback: function (val) {
                                    if (Math.floor(val) === val) {
                                        return val;
                                    }
                                }
                            },
                            scaleLabel: {
                                display: true,
                                labelString: this.msgSnapshot['CampaignReportComponent.item.rightAxis']
                            }
                        }]
                },
                legend: {
                    display: true
                }
            }
        };
        return data;
    };
    CampaignReportComponent.prototype.getDataObj = function () {
        var dataObj = {};
        dataObj.labels = [];
        dataObj.datasets = [];
        return dataObj;
    };
    CampaignReportComponent.prototype.showChart = function (originalData) {
        var _this = this;
        // let chartData = JSON.parse(JSON.stringify(originalData));
        var chartData = originalData;
        var chartOptions = this.getChartOption();
        var dataObj = this.getDataObj();
        var ctx = this.canvasElement.nativeElement;
        // 旧グラフが残ると描画不備となるので削除する
        if (this.myChart) {
            this.myChart.destroy();
        }
        var labelNum = chartData.labels.length;
        var datasetsNum = chartData.datasets.length;
        // 横軸のラベルループ
        for (var i = 0; i < labelNum; i++) {
            dataObj.labels.push(chartData.labels[i]);
        }
        // 折れ線グラフの必要色数を決める
        var lineColorsRequired = datasetsNum - 1;
        for (var i = 0; i < datasetsNum; i++) {
            var graphData = {};
            // グラフ表示スキップ設定
            if (chartData.datasets[i]['isDisp'] == false) {
                continue;
            }
            if (chartData.datasets[i]['isTarget'] == true) {
                chartData.datasets[i]['label'] = this.msgSnapshot['CampaignReportComponent.item.goal'];
                // 目標線の設定
                graphData = this.getGoalDataFormat();
                // 選択した年月が前月のとき目標線は非表示
                var rd = new Date(this.condition['report_date']);
                var d = new Date();
                d.setDate(1);
                d.setHours(0, 0, 0, 0);
                if (rd.getTime() < d.getTime()) {
                    graphData.hidden = true;
                }
                // 目標線の文言を上書き
                chartOptions.options.scales.yAxes[1].scaleLabel.labelString = this.msgSnapshot['CampaignReportComponent.item.rightAxisTarget'];
                // 目標線の色は固定
                lineColorsRequired--;
            }
            else if (chartData.datasets[i]['isTotal'] == true) {
                // 全体合計の設定
                chartData.datasets[i]['label'] = this.msgSnapshot['CampaignReportComponent.item.total'];
                graphData = this.getTotalDataFormat();
            }
            else {
                // 折れ線グラフの設定
                graphData = this.getLindeDataFormat();
                var color = this.getLineColor(lineColorsRequired);
                graphData.borderColor = color;
                graphData.backgroundColor = color;
            }
            graphData.data = [];
            graphData.label = chartData.datasets[i]['label'];
            for (var j = 0; j < chartData.datasets[i].data.length; j++) {
                if (chartData.datasets[i]['isTarget'] == true) {
                    graphData.data.push(this.target['value']);
                }
                else {
                    graphData.data.push(chartData.datasets[i].data[j]);
                }
            }
            dataObj.datasets.push(graphData);
        }
        chartOptions.data = dataObj;
        //this.hsl = 0;
        this.colorSeq = 0;
        // if(this.myChart){
        //     this.myChart.update(chartOptions);
        // }else {
        this.myChart = new Chart(ctx, chartOptions);
        // }
        this.reportClicked = false;
        ctx.addEventListener('click', function (e) { return _this.reportClickEvent(e); });
    };
    // グラフエリアクリック時のイベント
    CampaignReportComponent.prototype.reportClickEvent = function (e) {
        var activePoints = this.myChart.getElementsAtEvent(e);
        if (activePoints.length > 0 && this.reportClicked == false) {
            var clickedElementindex = activePoints[0]['_index'];
            //get specific label by index
            var label = this.myChart.data.labels[clickedElementindex];
            //get value by index
            //let value = this.myChart.data.datasets[0].data[clickedElementindex];
            // 年別から月別
            if (label.match(/^\d{4}$/)) {
                this.changeAxis('monthly');
            }
            // 月別から日別
            if (label.match(/^\d{4}\/\d{2}$/)) {
                this.changeDate(label);
            }
            this.reportClicked = true;
        }
    };
    // HSL
    // getLineColor(){
    //     // グラフの色設定
    //     this.hsl += 36;
    //     if(this.hsl % 360 == 72) this.hsl += 36;
    //     // let color = {r: 0, g: 0, b: 0};
    //     // for (let j in color) color[j] = Math.floor(Math.random() * 256);
    //     //let randomColor = "rgba(" + color.r + ", " + color.g + ", " + color.b + ",1)";
    //     let lineColor = "hsl("+this.hsl+", 100%, 50%)";
    //     return lineColor;
    // }
    CampaignReportComponent.prototype.changeDate = function (date) {
        this.condition['report_date'] = date;
        this.changeAxis('daily');
    };
    CampaignReportComponent.prototype.changeAxis = function (axis) {
        this.condition['axis'] = axis;
        this.postReport();
    };
    CampaignReportComponent.prototype.changeCategory = function (category) {
        this.condition['category'] = category;
        this.postReport();
    };
    CampaignReportComponent.prototype.postReport = function () {
        var _this = this;
        this.logger.debug('condition', this.condition);
        this.service.postCampaignReport(this.condition).subscribe(function (rec) {
            if (typeof rec !== 'undefined') {
                _this.showChart(rec);
            }
        });
    };
    CampaignReportComponent.prototype.getLineColor = function (num) {
        var lineColor;
        if (num <= 5) {
            lineColor = this.colors5[this.colorSeq];
        }
        if (6 <= num && num <= 10) {
            lineColor = this.colors10[this.colorSeq];
        }
        if (11 <= num && num <= 15) {
            lineColor = this.colors15[this.colorSeq];
        }
        if (16 <= num) {
            // 20色超える場合はリセットする
            if (this.colorSeq == 20) {
                this.colorSeq = 0;
            }
            lineColor = this.colors20[this.colorSeq];
        }
        this.colorSeq++;
        return lineColor;
    };
    CampaignReportComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'campaign-report',
                    template: "<dl [hidden]=\"defMode !== mode\" class=\"form\" id=\"{{ componentName }}\">\n  <dt class=\"form_dt\"></dt>\n  <dd>\n    <div>\n      <ul style=\"border-bottom: 1px solid rgba(0,0,0,.1);\" class=\"tabsMenu2\">\n        <li [class.tabsMenu2_current]=\"condition['axis'] === 'daily'\"><a href=\"javascript:void(0);\" (click)=\"changeAxis('daily')\">{{ (msg | async)['CampaignReportComponent.item.daily'] }} </a></li>\n        <li [class.tabsMenu2_current]=\"condition['axis'] === 'monthly'\"><a href=\"javascript:void(0);\" (click)=\"changeAxis('monthly')\">{{ (msg | async)['CampaignReportComponent.item.monthly'] }}</a></li>\n        <li [class.tabsMenu2_current]=\"condition['axis'] === 'yearly'\"><a href=\"javascript:void(0);\" (click)=\"changeAxis('yearly')\">{{ (msg | async)['CampaignReportComponent.item.yearly'] }}</a></li>\n      </ul>\n      <p *ngIf=\"condition['axis'] === 'daily'\" class=\"-mt-1\">\n        <label>{{ (msg | async)['CampaignReportComponent.item.selectDay'] }}</label>\n        <column-month [col]=\"{key: 'report_date', controlType: 'month', params: {options: monthOptions}}\" [val]=\"condition['report_date']\" [msg]=\"(msg | async)\" (changeVal)=\"changeDate($event.val)\"></column-month>\n      </p>\n      <div class=\"-my-2\">\n        <ul class=\"tabsMenu2\">\n          <li [class.tabsMenu2_current]=\"condition['category'] === 'media'\"><a href=\"javascript:void(0);\" (click)=\"changeCategory('media')\">{{ (msg | async)['CampaignReportComponent.item.media'] }}</a></li>\n          <li [class.tabsMenu2_current]=\"condition['category'] === 'segment'\"><a href=\"javascript:void(0);\" (click)=\"changeCategory('segment')\">{{ (msg | async)['CampaignReportComponent.item.segment'] }}</a></li>\n          <li [class.tabsMenu2_current]=\"condition['category'] === 'measure'\"><a href=\"javascript:void(0);\" (click)=\"changeCategory('measure')\">{{ (msg | async)['CampaignReportComponent.item.measure'] }}</a></li>\n          <li [class.tabsMenu2_current]=\"condition['category'] === 'language'\"><a href=\"javascript:void(0);\" (click)=\"changeCategory('language')\">{{ (msg | async)['CampaignReportComponent.item.language'] }}</a></li>\n        </ul>\n      </div>\n    </div>\n    <div>\n      <ul class=\"content\">\n        <li>\n          <div class=\"l-chart\" style=\"position: relative;\">\n            <canvas id=\"mixed-namacha\" #canvas></canvas>\n          </div>\n        </li>\n      </ul>\n    </div>\n  </dd>\n</dl>\n"
                }] }
    ];
    /** @nocollapse */
    CampaignReportComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: CampaignService }
    ]; };
    CampaignReportComponent.propDecorators = {
        canvasElement: [{ type: ViewChild, args: ['canvas',] }]
    };
    return CampaignReportComponent;
}(ContentBaseComponent));
export { CampaignReportComponent };
var MonthOptions = /** @class */ (function () {
    function MonthOptions() {
        this.MonthFormat = 'yy/mm';
    }
    return MonthOptions;
}());
//# sourceMappingURL=campaign-report.component.js.map